import React from 'react';
import { ResponsiveAutocomplete } from '@/components/selects/ResponsiveAutocomplete';
import { IMPORT_TYPES } from './importTypes';

/**
 * Pick import types (users, clients, claims), for the import history's Type filter.
 * value/onChange are a list of types. Other props go to ResponsiveAutocomplete.
 */
export const ImportTypePicker = (props) => (
	<ResponsiveAutocomplete options={IMPORT_TYPES} multiple {...props} />
);
